import React, {useState} from "react";
import AddIcon from "@material-ui/icons/Add";
import Fab from "@material-ui/core/Fab";
import Zoom from "@material-ui/core/Zoom";
function CreateArea(props) {

  const [note, setNote] = useState({title: "", content: ""});
  const [isClicked, setIsClicked] = useState(false);

  //Creates a new note and sets the values taken from the elements with the appropriate name
  function updateNote(e) {
    const {name, value} = e.target;
    setNote((prevNote) => {
      return {
        ...prevNote,
        [name]: value
      }
    });
  }

  function changeClicked() {
    setIsClicked(true);
  }

  return (<div>
    {/* Adding a note on form submit allowing prevent default submit action of reloading the page */}
    <form className="create-note" onSubmit={(e) => {
        props.onAdd(note);
        //Reset note values to clear input fields
        setNote({title: "", content: ""});
        e.preventDefault();
      }}>
      {isClicked && <input onChange={updateNote} name="title" placeholder="Title" value={note.title}/>}
      <textarea onChange={updateNote} onClick={changeClicked} name="content" placeholder="Take a note..." rows={isClicked ? "3" : "1"} value={note.content}/>
      {isClicked && <Zoom in={true}>
        <Fab type="submit">
          <AddIcon />
        </Fab>
      </Zoom> }
    </form>
  </div>);
}

export default CreateArea;
